export default __webpack_public_path__ + "static/media/5_image_1.49f38425.jpg";